module.exports = __webpack_public_path__ + "img/20220312_144717.82db9cac.jpg";